export const selectDataSet = (selectOptions, placeholder, placeholderText) => {
  const options = selectOptions.map(name => {
    return {
      value: name,
      label: name,
    };
  });

  return [placeholder(placeholderText), ...options];
};

export const selectBaseDataSet = selectOptions => {
  const options = selectOptions.map(name => {
    return {
      value: name,
      label: name,
    };
  });

  return [...options];
};
